import logo from "./ngs-logo.png";

interface LogoProps {
  maxWidth?: string;
  maxHeight?: string;
}

export const Logo = ({ maxWidth = "130px", maxHeight = "40px" }: LogoProps) => {
  return (
    <img
      src={logo}
      alt="NGS Logo"
      style={{
        width: "100%",
        height: "auto",
        maxWidth,
        maxHeight,
      }}
    />
  );
};
